import { useContext, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import CreateCancelmicro from "../../../../components/forms/CreateCancelmicro";
import TabelFinance from "../../../../components/tabel/tabelFinance/TabelFinance";
import DashboardContext from "../../../../Context";
import FromPaymentReceipt from "../../../financialdepartment/PaymentReceipt/FromPaymentReceipt";

export default function PaymentReceiptCustomer() {
    const { sideBardata, handelEdit, showformmicro, handeldmicro, } = useContext(DashboardContext)

    const [arryactions, setArryactions] = useState([]);
    const [sohwForm, setSohwForm] = useState(false);

    useEffect(() => {
        if (sideBardata) {
            sideBardata.map(item => {
                item.controllers.filter(find => {
                    if (`/${find.controller}` === '/PaymentReceipt') {
                        setArryactions(find.actions)
                        return find
                    }
                })
            })
        }
    }, []);


    const handelEditform = (id) => {
        setSohwForm(false)
        handeldmicro(false)
        handelEdit(id)
    }

    const additem = () => {
        setSohwForm(true)
    }

    const handelForm = () => setSohwForm(false)

    return (
        <>
            <Row>
                <Col md={12} sm={12} xs={12} >
                    {
                        sohwForm ?
                            <Button variant='danger' className='mb-3' onClick={() => handelEditform('')} >لغو</Button>
                            : arryactions.includes("Create") ?
                                <button type="button" className="btn btn-primary btn-icon-text btn-sm" onClick={additem} >
                                    افزودن {" "}
                                    <i className="fa fa-plus fa-lg"></i>
                                </button>
                                : null
                    }
                </Col>
            </Row>
            {
                sohwForm ?
                    <FromPaymentReceipt handelForm={handelForm} urlWebsilte='/PaymentReceipt' />
                    :
                    arryactions.includes('Get') ? <TabelFinance urldata='/PaymentReceipt' isCheck arryactions={arryactions} isnoid /> : "شما اجزا دسترسی به این بخش را ندارید :("
            }
        </>
    );
}
